export default __webpack_public_path__ + "static/media/product-mercedes.eab0e3dc.png";